module.exports = __webpack_public_path__ + "img/sword-silver.34623b0a.svg";